import React from "react";
import { FaPlay } from "react-icons/fa6";

export default function AudioConsultationButton({
  startTranscription,
  setShowAudioConsultationModal,
}) {
  const handleStartClick = () => {
    startTranscription();
    setShowAudioConsultationModal(true);
  };

  return (
    <div className="audio-consultation-button" onClick={handleStartClick}>
      <FaPlay size={14} className="icons-color" />
      <p>Start</p>
    </div>
  );
}
